import { ARTICULOS_AYUDA as DATOS_ARTICULOS } from './articulos.datos.mjs';

/** Claves de categoría de las preguntas frecuentes; `faqs.ts` las traduce al enum `FAQCategory`. */
export type CategoriaFaqArticulo = 'SETUP' | 'SECURITY' | 'PRICING' | 'CLINICAL' | 'TECHNICAL';

/** Destino de tablero que el backend acepta en un enlace del chat (lista blanca de bloquesMensaje). */
export interface EnlaceEnApp {
    readonly seccion: string;
    readonly recursoId: null;
}

export interface ArticuloAyuda {
    readonly slug: string;
    readonly titulo: string;
    /** Entre una y tres frases: es lo que el chat cita literalmente al terapeuta. */
    readonly respuestaCorta: string;
    /** Párrafos de la página pública del artículo. */
    readonly cuerpo: readonly string[];
    readonly palabrasClave: readonly string[];
    readonly enlaceEnApp: EnlaceEnApp | null;
    /** El «Abrir en el tablero →» del chat abre el diálogo de subida; solo con `enlaceEnApp` en Documentos. */
    readonly abreSubida?: boolean;
    /** YYYY-MM-DD. */
    readonly actualizadoEn: string;
    /** Solo en los artículos que vienen de una pregunta frecuente del centro de ayuda. */
    readonly faq?: { readonly id: string; readonly categoria: CategoriaFaqArticulo };
}

// El módulo de datos es JavaScript y TypeScript infiere `categoria` como string. La aserción es segura porque
// `scripts/generarCopiaAyuda.mjs` (validarArticulosAyuda) rechaza cualquier categoría fuera de las cinco y
// las pruebas de ayuda/ lo ejecutan sobre estos mismos datos.
export const ARTICULOS_AYUDA = DATOS_ARTICULOS as readonly ArticuloAyuda[];

export function articuloPorSlug(slug: string): ArticuloAyuda | undefined {
    return ARTICULOS_AYUDA.find((articulo) => articulo.slug === slug);
}
